import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.teams_index> = {
  queryKey: 'teams',
  query: QUERY,
}

export default List
